import React, { Suspense } from 'react';
import Loading from 'components/shared/loading/loading';
import ErrorBoundary from 'components/shared/error-boundary';
import { RequireAuth, useAuth } from 'providers/auth-provider';
import Header from './header';
import ClientRoutes from '../shared/client-routes';
import OpenRoutes from '../shared/open-routes';
import AssessmentRoutes from '../shared/assessment-routes';
import AssessmentsDataProvider from '../../providers/assessments-data-provider';
import { ROLES } from '../../config/constants';
import EmployeeRoutes from '../shared/employee-routes';
import TopNav from './top-nav';

function Layout() {
  const { token, userRole } = useAuth();

  if (token) {
    return (
      <div className="h-100 w-100 overflow-hidden">
        <div className="flex-header shadow-sm z-index-2">
          <Header />
          {userRole === ROLES.CLIENT_USER ? <TopNav /> : ''}
        </div>
        <div className="flex-content bg-light h-100">
          <ErrorBoundary>
            <Suspense fallback={<Loading />}>
              {userRole === ROLES.ASSESSMENT_USER && (
                <RequireAuth role={ROLES.ASSESSMENT_USER}>
                  <AssessmentsDataProvider>
                    <AssessmentRoutes />
                  </AssessmentsDataProvider>
                </RequireAuth>
              )}
              {userRole === ROLES.CLIENT_USER && (
                <RequireAuth role={ROLES.CLIENT_USER}>
                  <ClientRoutes />
                </RequireAuth>
              )}
              {userRole === ROLES.EMPLOYEE_USER && (
                <RequireAuth role={ROLES.EMPLOYEE_USER}>
                  <AssessmentsDataProvider>
                    <EmployeeRoutes />
                  </AssessmentsDataProvider>
                </RequireAuth>
              )}
            </Suspense>
          </ErrorBoundary>
        </div>
      </div>
    );
  }

  return <OpenRoutes />;
}

export default Layout;
